module.exports = __webpack_public_path__ + "img/f29c565951fd08c211adae2269196703.png";